module.exports = __webpack_public_path__ + "static/working-advisor-expecting-couple-mobile.80f99779.webp";